import { HermesTokenResult, RefreshTokenExchangeResult } from '@kaligo/hermes';
import { User } from '@rd/types';
import { AuthAction, AuthActionTypes } from '../actions/auth.actions';
import { sanitizeLoginRef } from '../helpers/login-ref.helper';

export interface AuthState {
  user: User | null;
  tokenResult: HermesTokenResult | RefreshTokenExchangeResult | null;
  hermesLoading: boolean;
  // null: fetching data from APIs
  // we don't whether user is logged in yet
  isLoggedIn: boolean | null;
  isIdleCheckRunning: boolean;
  isSessionCheckRunning: boolean;
  ref: string | null;
}

const initialState: AuthState = {
  user: null,
  tokenResult: null,
  hermesLoading: false,
  isLoggedIn: null,
  isIdleCheckRunning: false,
  isSessionCheckRunning: false,
  ref: null,
};

export function authReducer(
  state: AuthState = initialState,
  action: AuthAction,
): AuthState {
  switch (action.type) {
    case AuthActionTypes.HANDLE_LOGIN_REDIRECT:
      return {
        ...state,
        hermesLoading: true,
      };
    case AuthActionTypes.START_IDLE_CHECK:
      return {
        ...state,
        isIdleCheckRunning: true,
      };
    case AuthActionTypes.START_SESSION_CHECK:
      return {
        ...state,
        isSessionCheckRunning: true,
      };
    case AuthActionTypes.LOAD_IFRAME_TOKEN_SUCCESS:
      return {
        ...state,
        tokenResult: action.payload.tokenResult,
        hermesLoading: false,
      };
    case AuthActionTypes.LOAD_RTR_TOKEN_SUCCESS:
      return {
        ...state,
        tokenResult: action.payload.tokenResult,
        hermesLoading: false,
      };
    case AuthActionTypes.LOGIN_USER:
      return {
        ...state,
        user: action.payload,
        isLoggedIn: true,
      };
    case AuthActionTypes.LOGOUT_USER_COMPLETE:
      return {
        ...state,
        hermesLoading: false,
        user: null,
        tokenResult: null,
        isLoggedIn: false,
        isSessionCheckRunning: false,
        isIdleCheckRunning: false,
        ref: null,
      };
    case AuthActionTypes.SET_LOGIN_REF: {
      const ref = sanitizeLoginRef(action.payload);

      if (!ref) {
        return state;
      }

      return {
        ...state,
        ref,
      };
    }
    case AuthActionTypes.SESSION_EXPIRED_FAIL:
      return {
        ...state,
        ref: null,
      };
  }

  return state;
}
